import React from "react"
import Layout from "../components/layout"
import Position from "../components/positions"


export default function Index() {
  return (
    <Layout>
      <Position/>
    </Layout>)

}
/*
<Container className="sectionPeople">
  <h1 className="pub2Title">Contact</h1>
  <Position/>
  <h1 className="pub2Title">Where are we located?</h1>
  <div>
    <br/>
    Columbia University
    <br/>
    Zuckerman Mind Brain Behavior Institute
    <br/>
    Jerome L. Greene Science Center
    <br/>
    3227 Broadway, L5-050
    <br/>
    New York, New York
    <br/>
  </div>
</Container>

 */